import { localStorageEnums } from "../constants/LocalStorageEnums";


export const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${window.localStorage.getItem(localStorageEnums.TOKEN)}`
};
